export default __webpack_public_path__ + "static/media/navbar-approved-templates-orange.94e90d04.svg";